import IStepFourModel from './IStepFourModel';

const StepFourModelInitialState: IStepFourModel = {
  khataratBimehNameh: null,
  moddatBimehNamehId: null,
  tarhSodoor: null,
  tarikhShoroBimehNameh: null,
  wepodDiscountCode: null,
  hazinehPaksazi: 0,
  masooliatMali: 0,
};

export default StepFourModelInitialState;
